import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, delay, ease }}
    >
      {children}
    </M>
  );
};

export const MaskLines = ({ lines, className = "", delay = 0.15, as = "h1", testId }) => {
  const Tag = as;
  return (
    <Tag className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, delay: delay + i * 0.12, ease }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const MaskWords = ({ words, className = "", delay = 0.15, testId }) => (
  <h1 className={className} data-testid={testId}>
    {words.map(([w, accent], i) => (
      <span key={i} className="inline-block overflow-hidden pb-[0.1em] -mb-[0.1em] align-top">
        <motion.span className={`inline-block ${accent ? "text-gold-ink" : ""}`} initial={{ y: "110%", rotate: 4 }} animate={{ y: "0%", rotate: 0 }}
          transition={{ duration: 1, delay: delay + i * 0.06, ease }}>
          {w}{i < words.length - 1 ? "\u00a0" : ""}
        </motion.span>
      </span>
    ))}
  </h1>
);

export const Eyebrow = ({ children, light = false, className = "" }) => (
  <p className={`eyebrow ${light ? "text-gold" : "text-forest/70"} ${className}`}>
    <span className={`inline-block h-px w-8 align-middle mr-3 ${light ? "bg-leaf" : "bg-leaf-ink"}`} />
    {children}
  </p>
);
